import { useState } from 'react';

export const SORT_DIR_DESC = 'desc';
export const SORT_DIR_ASC = 'asc';

export default function useSort({ defaultType, defaultDir } = {}) {
    const [type, setType] = useState(defaultType);
    const [dir, setDir] = useState(defaultDir);

    const toggleSort = (newType) => {
        let sortVal = type;
        let orderVal = dir;

        if (newType === type) {
            orderVal = dir === SORT_DIR_ASC ? SORT_DIR_DESC : SORT_DIR_ASC;
        } else {
            sortVal = newType;
            orderVal = SORT_DIR_ASC;
        }

        setType(sortVal);
        setDir(orderVal);
    };

    const sortBy = (type) => {
        setType(type);
    };

    const isAsc = (value) => type === value && dir === SORT_DIR_ASC;
    const isDesc = (value) => type === value && dir === SORT_DIR_DESC;

    return {
        toggleSort,
        sortBy,
        dir,
        type,
        isAsc,
        isDesc,
    };
}
